import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Polygon as GooglePolygon } from "@react-google-maps/api"
import bouncingSubject from "utils/bouncingSubject"
import activePolygonSubject from "utils/activePolygonSubject"

const Polygon = ({ options, id, paths, onLoad, type }) => {
  const [polygon, setPolygon] = useState(null)

  const handleLoad = (googlePolygon) => {
    setPolygon(googlePolygon)
    onLoad(googlePolygon)
  }

  const hidePolygon = () => {
    let strokeOpacity = 1
    let fillOpacity = 0.16
    const interval = setInterval(() => {
      polygon.setOptions({
        fillOpacity,
        strokeOpacity,
      })
      fillOpacity -= 0.01
      strokeOpacity -= 0.0625

      if (fillOpacity <= 0 || strokeOpacity <= 0) {
        clearInterval(interval)
        polygon.setOptions({
          fillOpacity: 0,
          strokeOpacity: 0,
        })
      }
    }, 10)
  }

  const showPolygon = () => {
    let strokeOpacity = 0
    let fillOpacity = 0
    const interval = setInterval(() => {
      fillOpacity += 0.01
      strokeOpacity += 0.0625
      polygon.setOptions({
        fillOpacity,
        strokeOpacity,
      })
      if (fillOpacity >= 0.16 || strokeOpacity >= 1) {
        clearInterval(interval)
        polygon.setOptions({
          fillOpacity: 0.16,
          strokeOpacity: 1,
        })
      }
    }, 10)
  }

  const toggleOpacity = (value) => {
    if (value) {
      hidePolygon()
    } else {
      showPolygon()
    }
  }

  useEffect(() => {
    if (type === "overview" && polygon) {
      bouncingSubject.attach(toggleOpacity)
    }

    return bouncingSubject.detach(toggleOpacity)
  }, [polygon])

  const handleMouseOver = () => {
    activePolygonSubject.notify(type)
  }

  const handleMouseOut = () => {
    activePolygonSubject.notify(null)
  }

  return (
    <GooglePolygon
      options={options}
      key={id}
      paths={paths}
      onLoad={handleLoad}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    />
  )
}

Polygon.propTypes = {
  options: PropTypes.shape({}).isRequired,
  onLoad: PropTypes.func,
  paths: PropTypes.arrayOf(PropTypes.any).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.string.isRequired,
}

Polygon.defaultProps = {
  onLoad: () => null,
}
export default Polygon
